<div class="body">
    <app-left-menu></app-left-menu>
    <div class="apps-right">
        <div class="page-container">
            <div class="inner-page-container">
                <div class="white">
                    <div class="page-title">
                        <div class="row">
                            <div class="col-md-5">
                                <h3>Existing Vendor </h3>
                            </div>
                            <div class="col-md-7 text-right">
                                <!-- <div class="action-btn">
                                    <button pButton pRipple label="" icon="las la-plus" title="Add" (click)="GoToCreate($event)"
                                        class="p-button-success p-mr-2"></button>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="form-container scroll-y">
                        <table class="normal-table">
                            <tr>

                                <td style="width:17%" class="text-right">
                                    Temp Customer <span class="hlt-txt">*</span>
                                </td>
                                <td>
                                    <div class="p-inputgroup">
                                        <input type="text" disabled pInputText>
                                        <button class="p-inputgroup-addon p-button" title="Add" type="button"
                                            (click)="showBasicDialog()">
                                            <i class="las la-search"></i>
                                        </button>
                                    </div>

                                </td>
                                <td class="text-right">Temp Customer Site <span class="hlt-txt">*</span></td>
                                <td><input disabled type="text" pInputText> </td>
                                <td></td>
                                <td></td>
                                
                            </tr>
                          
                        </table>
                     
                        <div class="card">
                            <p-toolbar styleClass="p-mb-4">
                                <ng-template pTemplate="left">
                                    <span class="p-input-icon-left">
                                        <i class="las la-search"></i>
                                        <input pInputText type="text"
                                            (input)="dt.filterGlobal($event.target.value, 'contains')"
                                            placeholder="Search..." />
                                    </span>
                                </ng-template>

                                <ng-template pTemplate="right">
                                    <button type="button" pButton pRipple icon="las la-file-excel"
                                        title="Export to Excel" class="p-button-success p-mr-2" pTooltip="XLS"
                                        tooltipPosition="bottom"></button>
                                </ng-template>
                            </p-toolbar>

                            <!-- <p-table #dt [value]="agentListGrid" [scrollable]="true" [rows]="10" [paginator]="true"
                                [rowsPerPageOptions]="[10,25,50,100]"
                                [globalFilterFields]="['agentNo','agentName','fatherName','mobileNo']"
                                [style]="{'overflow':'auto!important'}" [rowHover]="true" dataKey="id"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [showCurrentPageReport]="true" scrollHeight="200px"> -->
                                <p-table #dt [value]="VendorList" [rows]="10" [paginator]="true"
                                [rowsPerPageOptions]="[10,25,50,100]"
                                [globalFilterFields]="['LEVELNAME','markuppercentage','vatpercentage','USD','CAD','ZAR','Currency4','Currency5']"
                                [rowHover]="true" dataKey="id" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                 [showCurrentPageReport]="true">
                                <!-- <ng-template pTemplate="colgroup" let-columns>
                                    <colgroup>
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:100px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:150px">
                                        <col style="width:150px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                    </colgroup>
                                </ng-template> -->
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th style="text-align: center;width: 100px;" >Action</th>
                                        <th style="text-align: center;width: 100px;" pSortableColumn="agentNo" >S. No
                                            <p-sortIcon field="agentNo">
                                            </p-sortIcon>
                                        </th>
                                        <th  pSortableColumn="agentNo">Vendor Name<p-sortIcon field="agentNo"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="agentName">Rates Detail ( basic , DDC , LR FOV Etc..)<p-sortIcon field="agentName">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="agentName">What are the Strength as per Customer <p-sortIcon field="agentName">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="agentName">What is Customer Pain Point for this Vendor <p-sortIcon field="agentName">
                                            </p-sortIcon>
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-_agentListGrid>
                                    <tr>
                                        <td style="text-align: center">
                                            <button pButton pRipple title="Add" icon="pi pi-plus"
                                                class="p-button-success p-mr-2"></button>
                                            <button pButton pRipple title="Remove" icon="pi pi-trash"
                                                class="p-button-danger p-mr-2"></button>
                                        </td>

                                        <td style="text-align: center">
                                            {{_agentListGrid.sno}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.vendorname}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.ratesdetail}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.customerstrength}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.vendorpoint}}
                                        </td>
                                       
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                        <div class="sub-title">
                            <div class="row">
                                <div class="col-md-5">
                                    <h5>Comments </h5>
                                </div>
                                <div class="col-md-7"></div>
                            </div>
                        </div>
                        <table class="normal-table">
                            
                            <tr>
                                <td class="text-right">Comments<span class="hlt-txt">*</span></td>
                                <!-- <td> -->
                                    <td colspan="5"><textarea inputId="textarea" rows="2" cols="30" pInputTextarea></textarea></td>
                            </tr>
                            <tr>
                                <td colspan="6" class="text-center">
                                    <button pButton label="Save" class="p-button-success" icon="las la-check"></button>
                                    <button pButton label="Clear" class="p-button-warning" icon="las la-broom"></button>
                                </td>
                            </tr>
                        </table>
                        <p-dialog header="Customer" [(visible)]="displayBasic" [modal]="true"
                        [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                        <ng-template pTemplate="content">
                            <div class="popup-body">
                                <div class="search-container">
                                    <div class="p-inputgroup">
                                        <span class="p-float-label">
                                            <input type="text" id="inputtext" pInputText>
                                        </span>
                                        <button class="p-inputgroup-addon p-button" title="Search">
                                            <i class="pi pi-search"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card">
                                    <p-table [value]="_Expenses" selectionMode="single"
                                        [(selection)]="selectedRequest" (onRowSelect)="onRowSelectPopup($event)"
                                        (onRowUnselect)="onRowUnSelectPopup($event)" [paginator]="true" [rows]="10">
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <!-- <th *ngIf="_action != 'view'">
                                            </th> -->
                                                <th pSortableColumn="requestno">Customer Name <p-sortIcon
                                                        field="requestno">
                                                    </p-sortIcon>
                                                </th>
                                                <!-- <th pSortableColumn="requestedbranch">Customer Tally ID
                                                    <p-sortIcon field="requestedbranch">
                                                    </p-sortIcon>
                                                </th> -->
                                                <th pSortableColumn="requestperson">Customer Type <p-sortIcon
                                                        field="requestperson">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="requestedbranch">Is Transporter
                                                    <p-sortIcon field="requestedbranch">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="requestedbranch">Billing Cycle
                                                    <p-sortIcon field="requestedbranch">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="requestedbranch">Pan No
                                                    <p-sortIcon field="requestedbranch">
                                                    </p-sortIcon>
                                                </th>


                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-rowData let-_Expense>
                                            <tr>
                                                <!-- <td style="text-align: center" *ngIf="_action != 'view'">
                                                <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                                            </td> -->
                                                <td>{{_Expense.pettycashsettlementid}}</td>
                                                <td>{{_Expense.settlementamount}}</td>
                                                <!-- <td>{{_Expense.balanceamount}}</td> -->
                                                <td>{{_Expense.settlementamount}}</td>
                                                <td>{{_Expense.balanceamount}}</td>
                                                <td>{{_Expense.balanceamount}}</td>

                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            </div>
                        </ng-template>
                    </p-dialog>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>